import React, { useState, useRef, useEffect } from 'react';
import { Button, FormControlLabel, Radio, RadioGroup, Dialog, DialogContent } from "@mui/material";
import {
    ContentState,
    EditorState,
    convertFromHTML,
    convertToRaw,
} from "draft-js";
import { Add, LocalSee, FileDownloadOutlined } from "@mui/icons-material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import './Editor.css';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from '../../../../configs/api';
import colorConfigs from '../../../../configs/colorConfigs';
import Webcam from "react-webcam";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { saveAs } from "file-saver";
import axois from "../../../../configs/axois";
import { handleCapture } from '../../../../utils/covertTheBase64FormatIntoImage';
import { validateMin } from '../../../../utils/validateMin';
import { useTheme } from '../../../../components/hooks/useTheme';
import PleaseWaitPopup from '../../../PleaseWaitPopup';
import useDelete from '../../../../components/hooks/useDelete';
import useAuth from '../../../../components/hooks/useAuth';
import { CustomImagePopup } from '../../../../components/common/CustomImagePopup';
import Cookies from 'js-cookie';
import useTenant from '../../../../components/hooks/useTenant';
import useConfirm from '../../../../components/hooks/useConfirm';

export const EditPaymentGatewaysForm = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { themeStyles, theme } = useTheme();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [paymentGateways, setPaymentGateways] = useState<any[]>([]);
    const [paymentGatewayData, setPaymentGatewayData] = useState<any | null>(null);
    const [isAuthentication, setIsAuthentication] = useState<boolean>(true);
    const [isWebsite, setIsWebsite] = useState<boolean>(true);
    const [paymentGateWayMenuItemId, setPaymentGateWayMenuItemId] = useState<string>("");
    const [label, setLabel] = useState<string>("");
    const [supportedCurrencies, setSupportedCurrencies] = useState<string>("");
    const [defaultCurrency, setDefaultCurrency] = useState<string>("");
    const [apiLoginId, setApiLoginId] = useState<string>("");
    const [transactionKey, setTransactionKey] = useState<string>("");
    const [isChangeTransactionKey, setIsChangeTransactionKey] = useState<boolean>(false);
    const [publicKey, setPublicKey] = useState<string>("");
    const [isChangePublicKey, setIsChangePublicKey] = useState<boolean>(false);
    const [active, setActive] = useState<string>("No");
    const [threeDsEnabled, setThreeDsEnabled] = useState<string>("No");
    const [skipCreditCardStorage, setSkipCreditCardStorage] = useState<string>("No");
    const [collectBillingAddress, setCollectBillingAddress] = useState<string>("No");
    const [onlyInternalCharges, setOnlyInternalCharges] = useState<string>("No");
    const [allowprocessingpaymentsAfterDeactivation,
        setAllowprocessingpaymentsAfterDeactivation] = useState<string>("No");
    const [testMode, setTestMode] = useState<string>("No");
    const [onlyPublicCharges, setOnlyPublicCharges] = useState<string>("No");
    const [authorizedUserRoles, setAuthorizedUserRoles] = useState<string>("");
    const [order, setOrder] = useState<string>("");
    const [commentforForm, setCommentforForm] = useState<string>("");
    const [textforPaymentButtonOnForm, setTextforPaymentButtonOnForm] = useState<string>("");
    const [textforAuthorizationButtonOnForm, setTextforAuthorizationButtonOnForm] = useState<string>("");
    const [textForSaveCreditCardButtonOnForm, setTextForSaveCreditCardButtonOnForm] = useState<string>("");
    const [filePath, setFilePath] = useState<string>("");
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [customCss, setCustomCss] = useState<string>('');
    const customCssLines = customCss.split('\n').length;

    const [customHtmlAfterBody, setCustomHtmlAfterBody] = useState<string>('');
    const customHtmlAfterBodyLines = customHtmlAfterBody.split('\n').length;

    const [customHtmlBeforeBody, setCustomHtmlBeforeBody] = useState<string>('');
    const customHtmlBeforeBodyLines = customHtmlBeforeBody.split('\n').length;

    const [showWebcam, setShowWebcam] = useState<boolean>(false);

    const webRef = useRef(null);
    const inputFileRef = useRef<HTMLInputElement>(null);
    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setFilePath(response.data);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });

        } else {
            setPleaseWaitPopup(false);
        }
    };

    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}commonFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    setFilePath(`${baseURL}commonFile/Get?name=${response.data}`)
                    axios
                        .put(`${baseURL}paymentGateway?userId=${auth?.id}`, JSON.stringify({
                            id: state,
                            paymentGateWayMenuItemId,
                            label,
                            supportedCurrencies,
                            defaultCurrency,
                            publicClientKey: publicKey,
                            transactionKey,
                            apiLoginId,
                            isActive: active === "Yes" ? true : false,
                            testMode: testMode === "Yes" ? true : false,
                            skipCreditCardStorage: skipCreditCardStorage === "Yes" ? true : false,
                            collectBillingAddress: collectBillingAddress === "Yes" ? true : false,
                            onlyInternalCharges: onlyInternalCharges === "Yes" ? true : false,
                            onlyPublicCharges: onlyPublicCharges === "Yes" ? true : false,
                            allowprocessingpaymentsAfterDeactivation: allowprocessingpaymentsAfterDeactivation === "Yes" ? true : false,
                            authorizedUserRoles,
                            imagesName: response.data,
                            order,
                            customCSS: customCss,
                            customHTMLAfterBody: customHtmlAfterBody,
                            customHTMLBeforeBodyCloseTag: customHtmlBeforeBody,
                            commentforForm,
                            textforPaymentButtonOnForm,
                            textforAuthorizationButtonOnForm,
                            textForSaveCreditCardButtonOnForm,
                        }), {
                            headers: {
                                'X-Tenant-ID': tenantId,
                                "Content-Type": "application/json"
                            },
                            withCredentials: true,
                        })
                        .then(() => {
                            setPleaseWaitPopup(false);
                            handleTenantError(null);
                        })
                        .catch((error) => {
                            setPleaseWaitPopup(false);
                            handleTenantError(error);
                        });
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }

    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        if (active === "Yes") {
            await axios.get(`${baseURL}paymentGateway/DoesPaymentGatewayExist/${state}`,
                {
                    headers: {
                        'X-Tenant-ID': tenantId
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res?.data) {
                        setConfirmData({
                            title: 'Warning',
                            summary: "An active payment gateway already exists. Activating this gateway will automatically deactivate the current active gateway. Do you want to continue?",
                            confirmBtn: 'Ok',
                            isConfirm: (callback: any) => {
                                setPleaseWaitPopup(true);
                                submitTheForm();
                                callback();
                            }
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    } else {
                        submitTheForm();
                    }
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            submitTheForm();
        }
    }

    const submitTheForm = async () => {
        await axios
            .put(`${baseURL}paymentGateway?userId=${auth?.id}`, JSON.stringify({
                id: state,
                paymentGateWayMenuItemId,
                label,
                supportedCurrencies,
                defaultCurrency,
                publicClientKey: publicKey === "" ? paymentGatewayData?.publicClientKey : publicKey,
                transactionKey: transactionKey === "" ? paymentGatewayData?.transactionKey : transactionKey,
                apiLoginId,
                isActive: active === "Yes" ? true : false,
                testMode: testMode === "Yes" ? true : false,
                skipCreditCardStorage: skipCreditCardStorage === "Yes" ? true : false,
                collectBillingAddress: collectBillingAddress === "Yes" ? true : false,
                onlyInternalCharges: onlyInternalCharges === "Yes" ? true : false,
                onlyPublicCharges: onlyPublicCharges === "Yes" ? true : false,
                allowprocessingpaymentsAfterDeactivation: allowprocessingpaymentsAfterDeactivation === "Yes" ? true : false,
                authorizedUserRoles,
                imagesName: filePath,
                order,
                customCSS: customCss,
                customHTMLAfterBody: customHtmlAfterBody,
                customHTMLBeforeBodyCloseTag: customHtmlBeforeBody,
                commentforForm,
                textforPaymentButtonOnForm,
                textforAuthorizationButtonOnForm,
                textForSaveCreditCardButtonOnForm,
            }), {
                headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                },
                withCredentials: true,
            })
            .then(() => {
                setPleaseWaitPopup(false);
                navigate(-1);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    }

    const maskKey = (key?: string) => {
        if (!key || key.trim().length === 0) {
            return "******";
        }

        const trimmedKey = key.trim();

        if (trimmedKey.length <= 6) {
            return "*".repeat(trimmedKey.length);
        }

        const firstThree = trimmedKey.slice(0, 3);
        const lastThree = trimmedKey.slice(-3);
        const maskedPart = "******";

        return `${firstThree}${maskedPart}${lastThree}`;
    }


    useEffect(() => {
        axois
            .get(`${baseURL}paymentGatewayMenu`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
            .then(response => {
                setPaymentGateways(
                    response.data.map((item: any) => {
                        return {
                            id: item.id,
                            provider: item.provider
                        }
                    }));
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setPleaseWaitPopup(true);
        axois
            .get(`${baseURL}paymentGateway/${state}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
            .then((response) => {
                setPaymentGatewayData(response?.data);
                setPaymentGateWayMenuItemId(response.data.paymentGateWayMenuItemId);
                setLabel(response.data.label);
                setSupportedCurrencies(response.data.supportedCurrencies);
                setDefaultCurrency(response.data.defaultCurrency);
                setPublicKey("");
                setTransactionKey("");
                setApiLoginId(response.data.apiLoginId);
                setActive(response.data.isActive ? "Yes" : "No");
                setTestMode(response.data.testMode ? "Yes" : "No");
                setSkipCreditCardStorage(response.data.skipCreditCardStorage ? "Yes" : "No");
                setCollectBillingAddress(response.data.collectBillingAddress ? "Yes" : "No");
                setOnlyInternalCharges(response.data.onlyInternalCharges ? "Yes" : "No");
                setOnlyPublicCharges(response.data.onlyPublicCharges ? "Yes" : "No");
                setAllowprocessingpaymentsAfterDeactivation(response.data.allowprocessingpaymentsAfterDeactivation ? "Yes" : "No");
                setAuthorizedUserRoles(response.data.authorizedUserRoles);
                setFilePath(response.data.imagesName);
                setOrder(response.data.order);
                setCustomCss(response.data.customCSS);
                setCustomHtmlAfterBody(response.data.customHTMLAfterBody);
                setCustomHtmlBeforeBody(response.data.customHTMLBeforeBodyCloseTag);
                setTextforPaymentButtonOnForm(response.data.textforPaymentButtonOnForm);
                setTextforAuthorizationButtonOnForm(response.data.textforAuthorizationButtonOnForm);
                setTextForSaveCreditCardButtonOnForm(response.data.textForSaveCreditCardButtonOnForm);
                setEditorState(
                    EditorState.createWithContent(
                        ContentState.createFromBlockArray(
                            convertFromHTML(response.data.commentforForm).contentBlocks,
                            convertFromHTML(response.data.commentforForm).entityMap
                        )
                    )
                );
                setPleaseWaitPopup(false);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const downloadTheImage = () => {
        if (filePath.startsWith("data:image/png")) {
            handleConvertClick(filePath.replace("data:image/png;base64,", ""));
        } else {
            saveAs(
                `${baseURL}commonFile/download?name=${filePath}`,
                `${state.provider}.png`
            );
        }
    };

    const handleConvertClick = (base64Image: string) => {
        const byteCharacters = atob(base64Image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/png' });

        saveAs(blob, `${state.provider}.png`);
    };

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    useEffect(() => {
        setCommentforForm(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }, [editorState]);

    const deleteThePaymentGateway = () => {
        setDeleteData({
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Payment Gateway?`,
            isDelete: (callback: any) => {
                callback();

                setPleaseWaitPopup(true);

                fetch(`${baseURL}paymentGateway?id=${state}&userId=${auth?.id}`, {
                    method: 'DELETE',
                    headers: {
                        'X-Tenant-ID': tenantId,
                    }
                })
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                        handleTenantError(null);
                    })
                    .catch((error) => {
                        setPleaseWaitPopup(false);
                        handleTenantError(error);
                    });
            }
        });

        setDeletePopup(true);
    };

    const handleEdit = () => {
        setDisabled(false);
        setShowWebcam(false);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>
                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Payment Gateway - {paymentGateways.find((item: any) => item.id === parseInt(paymentGateWayMenuItemId))?.provider}</h2>
                                </div>

                                {
                                    disabled && (
                                        <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                                            onClick={handleEdit}
                                        >
                                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                                edit
                                            </span>
                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                                        </button>
                                    )
                                }
                            </div>

                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="grid grid-cols-3 gap-6">
                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={label}
                                                        disabled={disabled}
                                                        onChange={(e) => setLabel(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Supported Currencies</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={supportedCurrencies}
                                                        disabled={disabled}
                                                        onChange={(e) => setSupportedCurrencies(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div>
                                                    <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Supported Currencies</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                    />
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Currency</label>
                                                    <input
                                                        type="text"
                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        value={defaultCurrency}
                                                        disabled={disabled}
                                                        onChange={(e) => setDefaultCurrency(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <h5 className="mb-0 mt-4 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsAuthentication(!isAuthentication)}
                                        >
                                            {isAuthentication ? (
                                                <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                                            ) : (
                                                <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: themeStyles.topBar.textColor }}>Authentication</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isAuthentication &&
                                            <div className="grid grid-cols-3 gap-6 mt-2">
                                                <div className="space-y-4">
                                                    <div>
                                                        <div className="flex items-center gap-x-[0.125rem]">
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Transaction Key</label>
                                                            {
                                                                (!disabled && !isChangeTransactionKey)
                                                                && (
                                                                    <button
                                                                        type="button"
                                                                        className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                                                                        onClick={() => setIsChangeTransactionKey(true)}
                                                                    >
                                                                        Change
                                                                    </button>
                                                                )
                                                            }
                                                        </div>

                                                        {
                                                            isChangeTransactionKey
                                                                ? (
                                                                    <input
                                                                        type="text"
                                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                        value={transactionKey}
                                                                        disabled={disabled}
                                                                        onChange={(e) => setTransactionKey(e.target.value)}
                                                                        required
                                                                    />
                                                                ) : (
                                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                                                        {maskKey(paymentGatewayData?.transactionKey)}
                                                                    </span>
                                                                )
                                                        }
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Api Login ID</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={apiLoginId}
                                                            disabled={disabled}
                                                            onChange={(e) => setApiLoginId(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                                                        <RadioGroup
                                                            row
                                                            value={active}
                                                            onChange={(e) => setActive(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>3DS Enabled</label>
                                                        <RadioGroup
                                                            row
                                                            value={threeDsEnabled}
                                                            onChange={(e) => setThreeDsEnabled(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Skip Credit Card Storage?</label>
                                                        <RadioGroup
                                                            row
                                                            value={skipCreditCardStorage}
                                                            onChange={(e) => setSkipCreditCardStorage(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Collect Billing Address</label>
                                                        <RadioGroup
                                                            row
                                                            value={collectBillingAddress}
                                                            onChange={(e) => setCollectBillingAddress(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <div className="flex items-center gap-x-[0.125rem]">
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Public Key</label>
                                                            {
                                                                (!disabled && !isChangePublicKey)
                                                                && (
                                                                    <button
                                                                        type="button"
                                                                        className={`text-xs font-medium text-blue-600 hover:underline cursor-pointer ml-2 ${themeStyles.form.tailwindLabelTextColor}`}
                                                                        onClick={() => setIsChangePublicKey(true)}
                                                                    >
                                                                        Change
                                                                    </button>
                                                                )
                                                            }
                                                        </div>

                                                        {
                                                            isChangePublicKey
                                                                ? (
                                                                    <input
                                                                        type="text"
                                                                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                        value={publicKey}
                                                                        disabled={disabled}
                                                                        onChange={(e) => setPublicKey(e.target.value)}
                                                                        required
                                                                    />
                                                                ) : (
                                                                    <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>
                                                                        {maskKey(paymentGatewayData?.publicClientKey)}
                                                                    </span>
                                                                )
                                                        }
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Authorized User Roles</label>
                                                        <input
                                                            type="text"
                                                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                            value={authorizedUserRoles}
                                                            disabled={disabled}
                                                            onChange={(e) => setAuthorizedUserRoles(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Test Mode</label>
                                                        <RadioGroup
                                                            row
                                                            value={testMode}
                                                            onChange={(e) => setTestMode(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Only Public</label>
                                                        <RadioGroup
                                                            row
                                                            value={onlyPublicCharges}
                                                            onChange={(e) => setOnlyPublicCharges(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Only Internal Charges</label>
                                                        <RadioGroup
                                                            row
                                                            value={onlyInternalCharges}
                                                            onChange={(e) => setOnlyInternalCharges(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allow Processing Payments for Saved Credit Cards After Deactivation</label>
                                                        <RadioGroup
                                                            row
                                                            value={allowprocessingpaymentsAfterDeactivation}
                                                            onChange={(e) => setAllowprocessingpaymentsAfterDeactivation(e.target.value)}
                                                        >
                                                            <FormControlLabel
                                                                value="Yes" control=
                                                                {<Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="Yes"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                            <FormControlLabel value="No" control={
                                                                <Radio
                                                                    disabled={disabled}
                                                                    sx={{
                                                                        color: "gray",
                                                                        "&.Mui-checked": { color: "#167AC3" },
                                                                        "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                                                        "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                                                    }}
                                                                />} label="No"
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                                                        color: themeStyles.form.labelTextColor,
                                                                    },
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <h5 className="mb-0 mt-4 flex justify-start items-center cursor-pointer select-none"
                                            onClick={() => setIsWebsite(!isWebsite)}
                                        >
                                            {isWebsite ? (
                                                <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                                            ) : (
                                                <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                                            )}{" "}
                                            <div className="w-full flex flex-row justify-between items-center">
                                                <div style={{ color: themeStyles.topBar.textColor }}>Website</div>
                                            </div>
                                        </h5>
                                        <hr />

                                        {isWebsite &&
                                            <>
                                                <div className="grid grid-cols-3 gap-6 mt-2">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label
                                                                htmlFor="image"
                                                                style={{ fontSize: "12px", fontWeight: "bold" }}
                                                            >
                                                                Images
                                                                <br />
                                                                <div
                                                                    style={{
                                                                        maxWidth: "50%",
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                        gap: "5px",
                                                                        cursor: "pointer"
                                                                    }}
                                                                    onClick={() => setImagePopup(true)}
                                                                >
                                                                    {filePath &&
                                                                        <>
                                                                            <img
                                                                                src={filePath.startsWith("data:image/png") ?
                                                                                    filePath
                                                                                    :
                                                                                    `${baseURL}commonFile/Get?name=${filePath}`}
                                                                                width={40}
                                                                                height={40}
                                                                                alt="mailBarLogo"
                                                                            />
                                                                        </>
                                                                    }
                                                                </div>
                                                                <input
                                                                    type="file"
                                                                    accept="image/*"
                                                                    name="mailBarLogo"
                                                                    ref={inputFileRef}
                                                                    disabled={disabled}
                                                                    onChangeCapture={onFileChangeCapture}
                                                                    style={{ display: "none" }}
                                                                />
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        gap: "8px",
                                                                        marginTop: "8px",
                                                                    }}
                                                                >
                                                                    <p
                                                                        style={{
                                                                            border: "1px dashed black",
                                                                            borderRadius: "3px",
                                                                            padding: "3px 5px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            backgroundColor: "white",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={(e) => {
                                                                            if (inputFileRef.current !== null) {
                                                                                inputFileRef.current?.click();
                                                                            }
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        <Add className="text-[#167AC3] text-[14px] font-bold" />
                                                                        Add Image
                                                                    </p>

                                                                    <p
                                                                        style={{
                                                                            border: "1px dashed black",
                                                                            borderRadius: "3px",
                                                                            padding: "3px 5px",
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            backgroundColor: "white",
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => setShowWebcam(true)}
                                                                    >
                                                                        {" "}
                                                                        <LocalSee className="text-[#167AC3] text-[14px] font-bold" />
                                                                    </p>

                                                                    {filePath &&
                                                                        <p
                                                                            style={{
                                                                                border: "1px dashed black",
                                                                                borderRadius: "3px",
                                                                                padding: "3px 5px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                fontSize: "12px",
                                                                                backgroundColor: "white",
                                                                                cursor: "pointer"
                                                                            }}
                                                                            onClick={() => downloadTheImage()}
                                                                        >
                                                                            {" "}
                                                                            <FileDownloadOutlined
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    color: "black",
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                            />
                                                                        </p>
                                                                    }
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Order</label>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={order}
                                                                disabled={disabled}
                                                                onChange={(e) => setOrder(validateMin(e.target.value, 0).toString())}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Custom CSS</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customCssLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customCss}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomCss(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Custom HTML After Body</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customHtmlAfterBodyLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customHtmlAfterBody}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomHtmlAfterBody(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="mt-2">
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Custom HTML Before Body Close Tag</label>
                                                    <div className="code-editor">
                                                        <div className="line-numbers">
                                                            {Array.from({ length: customHtmlBeforeBodyLines }, (_, i) => (
                                                                <div key={i} className="line-number">
                                                                    {i + 1}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <textarea
                                                            className="code-input"
                                                            value={customHtmlBeforeBody}
                                                            disabled={disabled}
                                                            onChange={(e) => setCustomHtmlBeforeBody(e.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    className="quill-wrapper my-5"
                                                    style={{
                                                        ...(theme === 'dark' && {
                                                            '--quill-text-color': '#ffffff',
                                                            '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                                                        }),
                                                    } as React.CSSProperties}
                                                >
                                                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Comment For Form</label>
                                                    <Editor
                                                        editorState={editorState}
                                                        wrapperClassName="wrapper-class"
                                                        editorClassName={`editor-class border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        toolbarClassName="toolbar-class"
                                                        onEditorStateChange={setEditorState}
                                                        toolbar={{
                                                            inline: { inDropdown: true },
                                                            list: { inDropdown: true },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                        }}
                                                        readOnly={disabled}
                                                    />
                                                </div>

                                                <div className="grid grid-cols-3 gap-6 mt-2">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Text For Payment Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={textforPaymentButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextforPaymentButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Text For Save Credit Card Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={textForSaveCreditCardButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextForSaveCreditCardButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Text For Authorization Button on Form</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                                value={textforAuthorizationButtonOnForm}
                                                                disabled={disabled}
                                                                onChange={(e) => setTextforAuthorizationButtonOnForm(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        <div className="flex gap-4 mt-6">
                                            {
                                                !disabled && (
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg
                                                        }}
                                                        type="submit"
                                                    >
                                                        Save
                                                    </Button>
                                                )
                                            }

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color

                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteThePaymentGateway}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={showWebcam && !disabled}
                maxWidth="md"
                fullScreen={false}
                PaperProps={{
                    style: {
                        marginTop: "-16%",
                    },
                }}
            >
                <DialogContent sx={{ padding: "0px" }}>
                    <Webcam
                        width={480}
                        height={320}
                        ref={webRef}
                        screenshotFormat="image/png"
                        audio={false}
                        disabled={disabled}
                    />

                    <div
                        style={{
                            width: "100%",
                            height: "50px",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingBlock: "8px",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            backgroundColor: "#eeeeee",
                        }}
                    >
                        <div style={{ width: "50%" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                    border: colorConfigs.btn.cancel.border,
                                    color: colorConfigs.btn.cancel.color
                                }}
                                onClick={() => setShowWebcam(false)}
                            >
                                Cancel
                            </Button>
                        </div>

                        <div
                            style={{
                                width: "50%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: colorConfigs.topbar.bg,
                                    color: "white",
                                    borderRadius: "0",
                                    border: "none",
                                    textTransform: "capitalize",
                                    fontSize: "12px",
                                    "&: hover": {
                                        backgroundColor: colorConfigs.topbar.bg,
                                        color: "white",
                                    },
                                }}
                                onClick={() => {
                                    if (webRef.current !== null) {
                                        //@ts-ignore
                                        const imageSrc = webRef.current.getScreenshot();

                                        handleCapture(imageSrc, `${baseURL}commonFile/upload`, tenantId, (imageFilePath: string) => {
                                            if (imageFilePath) {
                                                setFilePath(imageFilePath);
                                            }
                                        })

                                        setShowWebcam(false);
                                    }
                                }}
                            >
                                Capture an Image
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={`${baseURL}/commonFile/Get?name=${filePath}`}
                imageBaseUrlPath="commonFile"
                updateFile={updateFile}
            />

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    )
}
